import React from "react";
import { Helmet } from "react-helmet";
import Image from "../../../../components/image";
import { asset } from "../../../../helpers/dom.helper";
import InterestingBlog from "../../../itemAndBlog/blog/interestingBlog";
import '../style.scss'
import { Media, MediaContextProvider } from "../../../../media";
import ShareBtn from "../../shareBtnContainer";
import {PACKAGING_BLOG} from "../../packagingBlogJson"
import { useRouteMatch} from "react-router-dom";

function BlogsPage() {  
  const match = useRouteMatch();  
  const selectedBlog = PACKAGING_BLOG.find(number => number.selectedBlog === match.params.blogitem)
  const scrollToSendUsMessage = (scrollTo) => {
    if (typeof window !== 'undefined') { 
      const sendUsMessage = document.getElementById(scrollTo);
      if (sendUsMessage) {
        const offset = 80;
        const top = sendUsMessage.offsetTop - offset;
        window.scrollTo({
          top,
          behavior: "smooth",
        });
      }
    }
  };
  
  function generateRandomNumbers() {
    let randomNumbers = [];
    let allNumberOfBlog = PACKAGING_BLOG.length
    for (let i = 0; i < 4; i++) {
      let randomNumber = Math.floor(Math.random() * allNumberOfBlog) + 1;
      randomNumbers.push(randomNumber);
    }    
    return randomNumbers;
  }
  
  let result = generateRandomNumbers();  
  
  return (
    selectedBlog && 
    <>
    <Helmet>
      <title>{selectedBlog ? selectedBlog.titleTag : 'Packaging Blog | Lussopack'}</title>
      <meta name="description" content={selectedBlog ? selectedBlog.metaDescription : 'Packaging Blog | Lussopack'} />
      <meta name="keywords" content={selectedBlog ? (selectedBlog.keyword || selectedBlog.titleTag) : 'Packaging Blog | Lussopack'} />        
      <link rel="canonical" href="https://lussopack.com/blog" />  
    </Helmet>
      <MediaContextProvider>
        <Media greaterThanOrEqual="md">        
        <div id="blogPage">
          <div className="contentContainer">
            <h2>{selectedBlog?.blogName}</h2>
            <div className="articleBy">
              <p className="date">                    
                    <Image
                      src={asset(`/images/packagingBlog/desktop/postDate.svg`)}
                      alt="postDate"
                      className="img-fluid"
                      width="20"
                      height="20"
                      style={{marginRight: "5px"}}
                    /> {selectedBlog?.datePost}</p>
              <p className="by">Article by : Lussopack</p>
            </div>
            <div className="imageContainer">
              <Image 
                src={asset(`${selectedBlog?.blogPageImageDesktop}`)} 
                alt="Luxury-Packaging-Market" 
                width="100%" 
                height="auto" 
              />
            </div>

            {
              selectedBlog?.blogContent.map((content, indexContent)=>{
                if(content.type === 'contentDescription'){
                  return  (<React.Fragment key={indexContent}>
                    {content.content?.map((contentDescription, indexListContent)=>{
                      if(contentDescription.img){                         
                        return <div className="d-flex justify-content-center mb-3 mt-3">
                          <img src={asset(contentDescription.img)}                 
                            width="70%" 
                            height="auto"
                            alt={contentDescription.img}
                            />
                          </div>
                      } else {
                        return <div className="blogDetail" key={indexListContent} dangerouslySetInnerHTML={{ __html: contentDescription }} />
                      }
                  })}</React.Fragment>)                
                } else {
                  return null; 
                }
              })
            }            
            <ShareBtn refLink={selectedBlog?.refLink}/>

              <div className="requestQuoteContainer">
                <button onClick={() => scrollToSendUsMessage("sendUsMessage")}>
                  Request a quote
                </button>
              </div>                    
          </div>
          <div className="interestingConatiner">
            <InterestingBlog 
                interest01={result[0]}        
                interest02={result[1]}     
                interest03={result[2]}       
                interest04={result[3]}     
            /> 
          </div>

        </div>
        </Media>
        <Media lessThan="md">
        <div id="blogPageMobile">
          <div className="contentContainer">
            <h2>{selectedBlog?.blogName}</h2>
            <div className="articleBy">
              <p className="date">                    
                  <Image
                    src={asset(`/images/packagingBlog/desktop/postDate.svg`)}
                    alt="postDate"
                    className="img-fluid"
                    width="10"
                    height="10"
                  /> {selectedBlog?.datePost}</p>
              <p className="by">Article by : Lussopack</p>
            </div>
            <div className="imageContainer">
              <Image 
                src={asset(`${selectedBlog?.blogPageImageMobile}`)}
                alt="Luxury-Packaging-Market" 
                width="100%" 
                height="auto" 
              />
            </div>

            {
              selectedBlog?.blogContent.map((content, indexContent)=>{
                if(content.type === 'contentDescription'){
                  return  (<React.Fragment key={indexContent}>
                    {content.content?.map((contentDescription, indexListContent)=>{
                      if(contentDescription.img){                         
                        return <div className="d-flex justify-content-center mb-3 mt-3">
                          <img src={asset(contentDescription.img)}                 
                            width="80%" 
                            height="auto" 
                            alt={contentDescription.img}
                          />
                          </div>
                      } else {
                        return <div className="blogDetail" key={indexListContent} dangerouslySetInnerHTML={{ __html: contentDescription }} />
                      }
                  })}</React.Fragment>)                
                } else {
                  return null; 
                }
              })
            }     

          </div>
          <ShareBtn refLink={selectedBlog?.refLink}/>
            <div className="requestQuoteContainer">
              <button
                onClick={() => scrollToSendUsMessage("sendUsMessageMobile")}
              >
                Request a quote
              </button>
            </div>
          <div className="interestingConatiner">
            <InterestingBlog 
                interest01={result[0]}        
                interest02={result[1]}     
                interest03={result[2]}       
                interest04={result[3]}     
            /> 
          </div>
        </div>
        </Media>
      </MediaContextProvider>      
    </>
  );
}

export default BlogsPage;
